export const name = 'addressInput' as const

export const AddressInputSymbol = Symbol('AddressInput')
